import { render, staticRenderFns } from "./DateRangeLegend.vue?vue&type=template&id=499da0a2&scoped=true&"
import script from "./DateRangeLegend.vue?vue&type=script&lang=js&"
export * from "./DateRangeLegend.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeLegend.vue?vue&type=style&index=0&id=499da0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499da0a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499da0a2')) {
      api.createRecord('499da0a2', component.options)
    } else {
      api.reload('499da0a2', component.options)
    }
    module.hot.accept("./DateRangeLegend.vue?vue&type=template&id=499da0a2&scoped=true&", function () {
      api.rerender('499da0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8QsvB6paVxk0p/JS/comp/DateRangeLegend.vue"
export default component.exports